'use strict';

import Fluxxor from 'fluxxor';
import Immutable from 'immutable';

import constants from '../constants';


var LayerStore = Fluxxor.createStore({
  initialize () {
    this.bindActions(
      constants.ADD_MODAL, this.onAddModal,
      constants.ADD_POPOVER, this.onAddPopover,
      constants.ADD_TOOLTIP, this.onAddTooltip,
      constants.REMOVE_LAYER, this.onRemove
    );
    this.setMaxListeners(0);
    this.state = Immutable.List();
  },

  onAddModal: function(payload) {
    this.state = this.state.push({
      component: payload.component,
      type: 'modal',
      modalStyle: payload.modalStyle
    });
    this.emit('change');
  },

  onAddPopover: function(payload) {
    this.state = this.state.push({component: payload.component, type: 'popover'});
    this.emit('change');
  },

  onAddTooltip: function(payload) {
    this.state = this.state.push({component: payload.component, type: 'tooltip'});
    this.emit('change');
  },

  onRemove: function() {
    this.state = this.state.pop();
    this.emit('change');
  }
});

export default LayerStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/stores/layers.js
 **/